import CheckoutStepper from '@components/CheckoutStepper';
import Arrow from '@monofront/design-system/visuals/Icons/Old/Arrow';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { Logo } from '@components/Logo';
import { ICheckoutSteps } from '@hooks/useCheckoutSteps';

interface IHeaderDesktopProps {
  step: ICheckoutSteps;
  isStepperDisplayed?: boolean;
}

const HeaderDesktop: React.FC<IHeaderDesktopProps> = ({
  step,
  isStepperDisplayed = true,
}) => {
  const tCatalog = useTranslations('Catalog');

  return (
    <header className="desktop-only">
      <div className="limited-width-container header-desktop-container">
        <div className="go-back">
          <Link href="/cart" legacyBehavior>
            <a data-testid="HeaderDesktop-go-back-to-cart">
              <Arrow
                color="var(--clr-link)"
                headDirection="left"
                width={10}
                height={10}
              />
              <span className="tw-lf-link-md tw-ml-4">
                {tCatalog('backToCart')}
              </span>
            </a>
          </Link>
        </div>
        <div className="logo-and-stepper">
          <div className="logo">
            <Link href="/" legacyBehavior>
              <a data-testid="HeaderDesktop-go-back-to-home">
                <Logo width={90} height={45} />
              </a>
            </Link>
          </div>
          {isStepperDisplayed && (
            <div className="stepper">
              <CheckoutStepper currentStep={step} />
            </div>
          )}
        </div>
        <div></div>
      </div>
      <style jsx>{`
        header {
          position: sticky;
          top: calc(
            var(--desktop-checkout-header-height-collapsed) -
              var(--desktop-checkout-header-height-expanded)
          );
          width: 100%;
          height: ${isStepperDisplayed
            ? 'var(--desktop-checkout-header-height-expanded)'
            : 'var(--desktop-checkout-header-height)'};
          background-color: var(--white);
          z-index: var(--zindex-sticky);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .go-back {
          top: var(--space-5);
          height: 100%;
          position: sticky;
        }

        .logo-and-stepper {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .stepper {
          margin-top: var(--space-3);
          width: 350px;
        }

        .header-desktop-container {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: var(--space-3) 0;
        }

        .header-desktop-container > div {
          flex: 1;
        }

        .header-desktop-container > :global(span) {
          margin: 0;
        }

        .header-desktop-container > h1 {
          font-size: var(--font-size-1);
        }

        // Prevent go back button to go outside our app container
        @media (min-width: 2000px) {
          .go-back {
            left: calc(50% - 860px);
          }
        }
      `}</style>
    </header>
  );
};

export default HeaderDesktop;
